import { Result } from "antd";
import React from "react";

const FormSuccess = () => {
  return (
    <Result
      icon={
        <svg
          width="192"
          height="140"
          viewBox="0 0 192 140"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M14.078 16.5817L18.4758 20.8938L28.948 10.2134"
            stroke="#00EDAA"
            stroke-width="2.63962"
            stroke-linecap="round"
          />
          <path
            d="M175.095 60.5754L179.493 64.8875L189.965 54.2071"
            stroke="#00EDAA"
            stroke-width="2.63962"
            stroke-linecap="round"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M26.8561 71.2854C26.8561 38.0095 53.8316 11.0341 87.1075 11.0341C120.383 11.0341 147.359 38.0095 147.359 71.2854C147.359 88.0207 140.851 105.494 126.674 116.69C112.667 127.754 90.6895 133.063 58.8889 124.78C58.232 124.447 57.4398 124.389 56.7034 124.687L41.0156 131.037L45.2431 116.349C45.5621 115.241 45.1225 114.094 44.2313 113.464C33.7575 102.598 26.8561 87.486 26.8561 71.2854ZM39.736 116.396C28.7951 104.699 21.5769 88.6173 21.5769 71.2854C21.5769 35.0939 50.916 5.75482 87.1075 5.75482C123.299 5.75482 152.638 35.0939 152.638 71.2854C152.638 89.2839 145.643 108.436 129.946 120.833C114.333 133.165 90.5924 138.441 57.78 129.947L37.9693 137.965L32.9423 140L34.4423 134.788L39.736 116.396Z"
            fill="#00EDAA"
          />
          <path
            d="M51.9126 60.4535C51.9126 58.8358 52.2312 57.234 52.8502 55.7395C53.4693 54.245 54.3766 52.887 55.5205 51.7432C56.6643 50.5993 58.0223 49.692 59.5168 49.0729C61.0113 48.4539 62.6131 48.1352 64.2308 48.1352C65.8484 48.1352 67.4503 48.4539 68.9448 49.0729C70.4393 49.692 71.7972 50.5993 72.9411 51.7432C74.085 52.887 74.9923 54.245 75.6114 55.7395C76.2304 57.234 76.549 58.8358 76.549 60.4535L72.8536 60.4535C72.8536 59.3211 72.6305 58.1998 72.1972 57.1537C71.7639 56.1075 71.1287 55.157 70.328 54.3563C69.5273 53.5556 68.5767 52.9204 67.5306 52.4871C66.4844 52.0537 65.3632 51.8307 64.2308 51.8307C63.0984 51.8307 61.9772 52.0537 60.931 52.4871C59.8848 52.9204 58.9343 53.5556 58.1336 54.3563C57.3329 55.157 56.6977 56.1075 56.2644 57.1537C55.8311 58.1998 55.608 59.3211 55.608 60.4535L51.9126 60.4535Z"
            fill="#00EDAA"
            stroke="#00EDAA"
            stroke-width="1.69612"
          />
          <path
            d="M107.345 60.4535C107.345 58.8358 107.663 57.234 108.282 55.7395C108.901 54.245 109.809 52.887 110.953 51.7432C112.096 50.5993 113.454 49.692 114.949 49.0729C116.443 48.4539 118.045 48.1352 119.663 48.1352C121.281 48.1352 122.882 48.4539 124.377 49.0729C125.871 49.692 127.229 50.5993 128.373 51.7432C129.517 52.887 130.424 54.245 131.043 55.7395C131.662 57.234 131.981 58.8358 131.981 60.4535L128.286 60.4535C128.286 59.3211 128.063 58.1998 127.629 57.1537C127.196 56.1075 126.561 55.157 125.76 54.3563C124.959 53.5556 124.009 52.9204 122.963 52.4871C121.916 52.0537 120.795 51.8307 119.663 51.8307C118.53 51.8307 117.409 52.0537 116.363 52.4871C115.317 52.9204 114.366 53.5556 113.566 54.3563C112.765 55.157 112.13 56.1075 111.696 57.1537C111.263 58.1998 111.04 59.3211 111.04 60.4535L107.345 60.4535Z"
            fill="#00EDAA"
            stroke="#00EDAA"
            stroke-width="1.69612"
          />
          <path
            d="M103.825 85.9698C103.825 87.5875 103.506 89.1893 102.887 90.6838C102.268 92.1783 101.361 93.5363 100.217 94.6801C99.0733 95.824 97.7154 96.7313 96.2209 97.3504C94.7263 97.9694 93.1245 98.288 91.5069 98.288C89.8892 98.288 88.2874 97.9694 86.7929 97.3504C85.2984 96.7313 83.9404 95.824 82.7966 94.6801C81.6527 93.5363 80.7454 92.1783 80.1263 90.6838C79.5073 89.1893 79.1886 87.5875 79.1886 85.9698H82.8841C82.8841 87.1022 83.1071 88.2234 83.5405 89.2696C83.9738 90.3158 84.609 91.2663 85.4097 92.067C86.2104 92.8677 87.1609 93.5029 88.2071 93.9362C89.2533 94.3695 90.3745 94.5926 91.5069 94.5926C92.6392 94.5926 93.7605 94.3695 94.8067 93.9362C95.8528 93.5029 96.8034 92.8677 97.6041 92.067C98.4048 91.2663 99.0399 90.3158 99.4733 89.2696C99.9066 88.2234 100.13 87.1022 100.13 85.9698H103.825Z"
            fill="#00EDAA"
            stroke="#00EDAA"
            stroke-width="1.69612"
          />
          <rect
            y="63.0931"
            width="107.345"
            height="19.6505"
            rx="9.82526"
            fill="#00EDAA"
            fill-opacity="0.13"
          />
          <rect
            x="38.1278"
            y="101.263"
            width="107.345"
            height="19.6505"
            rx="9.82526"
            fill="#00EDAA"
            fill-opacity="0.13"
          />
          <rect
            x="72.3676"
            y="82.2828"
            width="107.345"
            height="19.6505"
            rx="9.82526"
            fill="#00EDAA"
            fill-opacity="0.13"
          />
          <circle
            cx="152.716"
            cy="7.71918"
            r="5.71918"
            stroke="#00EDAA"
            stroke-width="3.76538"
          />
          <circle
            cx="18.1597"
            cy="116.273"
            r="4.59082"
            stroke="#00EDAA"
            stroke-width="2.63962"
          />
          <circle
            cx="154.414"
            cy="120.231"
            r="4.02545"
            stroke="#00EDAA"
            stroke-width="2.63962"
          />
        </svg>
      }
      className="form-success-create-cv"
      subTitle="Bạn đã nộp đơn ứng tuyển thành công. Chúng tôi sẽ sớm liên hệ lại bạn!"
    />
  );
};

export default FormSuccess;
